import { Link, useNavigate, useParams, useSearch } from "@tanstack/react-router";

import gen from "../generations/generations.module.css";
import { GenerationsGallery, type Kind } from "../generations/GenerationsGallery";
import { SoonControl } from "../Soon";
import classes from "./simple-sections.module.css";

const ROUTE = "/signed-in/teams/$teamId/brands/$brandId/studio/simple/library";
const LIBRARY = "/teams/$teamId/brands/$brandId/simple/library";

/**
 * The prototype's chips, in its order: a kind's own read, the gallery's; Ad copy, Favorites and
 * Recently deleted are no read of the jobs, so they are Coming soon (spec ui-perf/simple-library).
 */
const CHIPS: readonly ({ label: string; kind: Kind | undefined } | { label: string; soon: true })[] = [
  { label: "All", kind: undefined },
  { label: "Videos", kind: "video" },
  { label: "Images", kind: "image" },
  { label: "Audio", kind: "audio" },
  { label: "Ad copy", soon: true },
  { label: "Favorites", soon: true },
  { label: "Recently deleted", soon: true },
];

/** One brand's Library: Pro's Generations' gallery, on Simple's URL and chips. */
function BrandLibrary({ teamId, brandId }: { teamId: string; brandId: string }) {
  const { kind, job: linked } = useSearch({ from: ROUTE });
  const navigate = useNavigate({ from: LIBRARY });
  return (
    <div className={classes.page}>
      <h1 className={`${classes.title} ${classes.libraryTitle}`}>Library</h1>
      <GenerationsGallery
        teamId={teamId}
        brandId={brandId}
        kind={kind}
        linked={linked}
        onCloseLinked={() => void navigate({ search: { kind }, replace: true })}
        kinds={
          <nav className={gen.kinds} aria-label="Kinds">
            {CHIPS.map((each) =>
              "soon" in each ? (
                <SoonControl key={each.label} className={gen.kind}>
                  {each.label}
                </SoonControl>
              ) : (
                <Link
                  key={each.label}
                  to={LIBRARY}
                  params={{ teamId, brandId }}
                  search={{ kind: each.kind }}
                  className={gen.kind}
                  aria-current={each.kind === kind ? "page" : undefined}
                  activeOptions={{ exact: true, includeSearch: true }}
                >
                  {each.label}
                </Link>
              ),
            )}
          </nav>
        }
      />
    </div>
  );
}

/**
 * Simple's Library (spec ui-perf/simple-library): the Created AI Simple prototype's
 * `VIEWS.library`, everything the brand made, the user's or the team's, in days: Pro's
 * Generations' gallery with the prototype's chips. Another brand starts it anew.
 */
export function SimpleLibrary() {
  const { teamId, brandId } = useParams({ from: ROUTE });
  return <BrandLibrary key={`${teamId} ${brandId}`} teamId={teamId} brandId={brandId} />;
}
